import React from 'react'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    minWidth: 250,
    display: 'block',
    margin: '20px auto',
    maxWidth: 500
  }
})

const DevicePlaceholder = ({ classes }) => {
  return (
    <Typography
      className={classes.root}
      variant={'Headline'}
      color={'textSecondary'}
      align={'center'}
    >
      Esta página não pode ser visualizada no tamanho de tela atual. Recomendamos que acesse em uma
      tela maior.
    </Typography>
  )
}

export default withStyles(styles, { withTheme: true })(DevicePlaceholder)



// WEBPACK FOOTER //
// ./src/components/DevicePlaceholder.js